export type SettingType =
  'game_id'
  | 'auto_save'
  | 'stop_evaluation_on_start_of_the_week'
  | 'match_evaluation_fast_speed'
  | 'match_evaluation_show_incidents';

export default {
  // game id is used to be able to identify the game like for game slots when auto saving
  'game_id': null,
  // every x weeks to auto save
  'auto_save': false,
  // stop evaluation on mondays or not
  'stop_evaluation_on_start_of_the_week': false,
  'match_evaluation_fast_speed': true,
  // will show incidents as card on the match evaluation will short break
  'match_evaluation_show_incidents': false,
};
